// The one AudioContext for read-aloud playback and voice-mode level metering
// (BUILD 2 C2-8). Created on first use and resumed on the Voice-entry gesture,
// so browsers that lock audio until a gesture unlock it once. A closed context
// (after an interruption) is replaced. Written by WP2-0b; frozen after the
// b2-contracts tag.
let context: AudioContext | null = null;

export function sharedAudioContext(): AudioContext {
  if (!context || context.state === 'closed') context = new AudioContext();
  return context;
}
